import 'react-native-get-random-values'
import '@aikoa/i18n/register'
import 'expo-router/entry'
